module.exports = __webpack_public_path__ + "media/images/shop-register-bg-96ba34bc4bd5a9fe8cb323965061482e.jpeg";